<script setup lang="ts">

import type { ICrossSellProduct } from '~/interfaces/crossSell/ICrossSell';

const props = defineProps<{
  title?: string
  subtitle?: string
  crossSellItems: ICrossSellProduct[]
  small?: boolean
  currentIndex?: number
}>()

const {
  crossSellItems,
  small,
  currentIndex
} = toRefs(props)

const currentSlide = ref(currentIndex.value ?? 0);
const startX = ref(0);
const endX = ref(0);
const translateValue = ref(0);
const carousel = ref([]);
const carouselContainer = ref([]);

const prevSlide = () => {
  currentSlide.value = (currentSlide.value - 1 + crossSellItems.value.length) % crossSellItems.value.length;
  translateValue.value = currentSlide.value * 280;
}

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1 + crossSellItems.value.length) % crossSellItems.value.length;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  if (translateValue.value >= carousel.value.scrollWidth - carouselContainer.value.offsetWidth) {
    return;
  }
  translateValue.value = currentSlide.value * 280;
}

const startTouch = (e: TouchEvent) => {
  startX.value = e.touches[0].clientX;
}

const moveTouch = (e: TouchEvent) => {
  endX.value = e.touches[0].clientX;
  const diffX = startX.value - endX.value;
  translateValue.value = Math.abs(diffX) * 8;
}

</script>

<template>
  <div :class="small ? 'carousel-v2--small' : ''">
    <button v-if="currentSlide !== 0" class="control control--left caroussel__control control__arrow active" @click="prevSlide">
      <svg class="cicon pe-n">
        <use xlink:href="#left-v2"/>
      </svg>
    </button>
    <button
v-if="carousel.scrollWidth > carouselContainer.offsetWidth && translateValue <= carousel.scrollWidth - carouselContainer.offsetWidth"
            class="control control--right caroussel__control control__arrow active"
            @click="nextSlide">
      <svg class="cicon pe-n">
        <use xlink:href="#right-v2"/>
      </svg>
    </button>
    <div ref="carouselContainer" class="carousel-v2">
      <div ref="carousel" class="carousel-v2-inner" :style="{ transform: `translateX(-${translateValue}px)` }" @touchstart="startTouch" @touchmove="moveTouch">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>
